import React, { useEffect, useState } from 'react';
import ImageGalleryStyle from '../../../styles/imagegallery';
import { getScreenName } from '../../../Utils/helper';
import { SectionTitle } from '../../StoreHomePage/BannerGridCarousel/WaveCarousel.styled';
import CarouselContent from './CarouselContent';
import {
  CarouselContentDiv,
  CarouselCSS,
  SafeCarouselContainer,
} from './styled';
import ImageGallery from 'react-image-gallery';
import { fireEvent } from '../../../Utils/fireEvent';

export default function WhyDiaperSafeCarousel(props) {
  const { data, isForNewCdPage } = props;
  const [currentIndex, setCurrentIndex] = useState(0);
  const cardClickHandler = (item) => {
    fireEvent({
      category: 'clicked_card_in_myloshop',
      screen_name: getScreenName(),
      section_id: '',
      section_name: data?.heading,
      shape: 'Carousel',
      page_url: window.location.href.slice(0, 99),
      card_name: item?.heading,
      url: item?.mobileWebImage,
    });
  };

  useEffect(() => {
    fireEvent({
      category: 'served_section_in_myloshop',
      screen_name: getScreenName(),
      section_id: '',
      section_name: data?.heading,
      shape: 'Carousel',
      page_url: window.location.href.slice(0, 99),
    });
  }, []);

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < data?.items.length - 1 ? prevIndex + 1 : 0,
    );
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : data?.items.length - 1,
    );
  };

  return (
    <SafeCarouselContainer>
      <SectionTitle>
        <h2
          dangerouslySetInnerHTML={{
            __html: data?.heading,
          }}
        ></h2>
      </SectionTitle>
      <CarouselCSS isForNewCdPage={isForNewCdPage}>
        <ImageGalleryStyle />
        <ImageGallery
          items={data?.items}
          startIndex={currentIndex}
          renderItem={(item, index) => {
            return (
              <CarouselContentDiv
                key={`carousel${index}`}
                onClick={() => cardClickHandler(item)}
              >
                <CarouselContent
                  element={item}
                  isForNewCdPage={isForNewCdPage}
                  currentIndex={currentIndex}
                  setCurrentIndex={setCurrentIndex}
                  handleNext={handleNext}
                  handlePrev={handlePrev}
                />
              </CarouselContentDiv>
            );
          }}
          showBullets={true}
          showNav={false}
          showFullscreenButton={false}
          useBrowserFullscreen={false}
          showPlayButton={false}
          onSlide={(index) => {
            fireEvent({
              category: 'swiped_image',
              screen_name: getScreenName(),
              section_id: '',
              section_name: data?.heading,
              shape: 'Carousel',
              page_url: window.location.href.slice(0, 99),
              postion: currentIndex,
              card_name: data?.items[currentIndex]?.heading,
              url: data?.items[currentIndex]?.mobileWebImage,
            });
            setCurrentIndex(index);
          }}
        />
      </CarouselCSS>
    </SafeCarouselContainer>
  );
}
